import React,{ PureComponent } from "react";
import "./NoContent.scss";
import {Box, Container, Typography} from "@mui/material";

class NoContent extends PureComponent{
    render(){
        return <Container>
            <Box >
                    <Typography align={'center'} className={"no-content-text"}>
                        {this.props.children}
                    </Typography>
            </Box>

        </Container>
    }
}
export default NoContent;